import React, { useState } from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import { styles } from './styles'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import AppBar from '@material-ui/core/AppBar'
import Title from '../../components/Title'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { withContext } from '../../context'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { fetchAnnouncementList } from '../../stores/announcement'
import { isEmpty } from 'lodash'
import { Avatar, Col, Row, Space, Spin } from 'antd'
import {
  AnnouncementItem,
  CardContentEx,
  ColumnCenter,
  TagItem,
  Text
} from '../../shared.style'
import { isMobile, toBuddhistYear } from '../../utils'
import { CardMaterialEx } from '../../material.style'
import moment from 'moment'
import { ACTION } from '../../utils/constants'
import FactoryDetail from './FactoryDetail'
import LogoNoMaterial from '../../assets/images/icon_no_material_402x.png'

const FactoryAnnouncement = ({ history: { push }, context: { state } }) => {
  const dispatch = useDispatch()
  const { announcementList, isLoading } = useSelector(
    (state) => state.announcement
  )
  const [factoryDetail, setFactoryDetail] = useState(null)
  const [action, setAction] = useState(ACTION.LIST)

  useDeepEffect(() => {
    async function fetchData() {
      await dispatch(
        fetchAnnouncementList({
          isExpired: true
        })
      )
    }

    fetchData()
  }, [])

  function onClickItem(e, item) {
    e.preventDefault()
    setFactoryDetail(item)
    setAction(ACTION.DETAIL)
  }

  function onBack() {
    setFactoryDetail(null)
    setAction(ACTION.LIST)
  }

  return (
    <div>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          {action === ACTION.LIST && (
            <IconButton
              id="btnBack"
              color="inherit"
              aria-label="Menu"
              style={styles.menuButton}
              onClick={() => push(`/`)}>
              <BackIcon />
            </IconButton>
          )}
          {action === ACTION.DETAIL && (
            <IconButton
              id="btnBack"
              color="inherit"
              aria-label="Menu"
              style={styles.menuButton}
              onClick={() => onBack()}>
              <BackIcon />
            </IconButton>
          )}
          {action === ACTION.LIST && (
            <Typography
              id="titlePage"
              variant="h6"
              color="inherit"
              style={styles.grow}>
              หน้าหลัก
            </Typography>
          )}
          {action === ACTION.DETAIL && (
            <Typography
              id="titlePage"
              variant="h6"
              color="inherit"
              style={styles.grow}>
              กลับ
            </Typography>
          )}
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
        {state.uploading ? (
          <LinearProgress />
        ) : (
          <div style={{ height: '4px' }} />
        )}
      </AppBar>
      {action === ACTION.LIST && <Title name="ประกาศรับซื้อ" />}
      {action === ACTION.DETAIL && <Title name="ประกาศตามหาสินค้า" />}
      <CardMaterialEx width={1000} elevation={isMobile ? 0 : 1} square>
        {!isLoading ? (
          <CardContentEx>
            {action === ACTION.LIST && (
              <Row gutter={[8, 8]}>
                {!isEmpty(announcementList) ? (
                  announcementList.map((item, index) => {
                    return (
                      <Col span={24} key={index}>
                        <Row gutter={8} align="middle">
                          <Col span={4}>
                            <TagItem>{item.announcementType}</TagItem>
                          </Col>
                          <Col span={20}>
                            <AnnouncementItem
                              onClick={(e) => onClickItem(e, item)}>
                              <Row gutter={[8, 8]}>
                                <Col span={6}>
                                  <ColumnCenter>
                                    <Avatar
                                      src={item.material.productImage}
                                      size={64}
                                    />
                                  </ColumnCenter>
                                </Col>
                                <Col span={12}>
                                  <Row gutter={8}>
                                    <Col span={24}>
                                      <Space>
                                        <span>รับซื้อ</span>
                                        <span>{item.material.name}</span>
                                      </Space>
                                    </Col>
                                    <Col span={24}>
                                      <span>{item.productManagement}</span>
                                    </Col>
                                  </Row>
                                  <Row gutter={8} style={{ marginTop: '1rem' }}>
                                    <Col span={24}>
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          color: '#FF9300'
                                        }}>{`ราคา ${item.price} บาท ต่อ ${item.material.unit}`}</span>
                                    </Col>
                                    <Col span={24}>
                                      <span>{`ภายในวันที่ ${toBuddhistYear(
                                        moment(item.expirationDate),
                                        'LL'
                                      )}`}</span>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col span={6}>
                                  <ColumnCenter>
                                    <Row>
                                      <Col span={24}>
                                        <Row justify="center">
                                          <Avatar
                                            src={item.hero.image}
                                            size={48}
                                          />
                                        </Row>
                                      </Col>
                                      <Col span={24}>
                                        <Row justify="center">
                                          <Text>{item.hero.name}</Text>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </ColumnCenter>
                                </Col>
                              </Row>
                            </AnnouncementItem>
                          </Col>
                        </Row>
                      </Col>
                    )
                  })
                ) : (
                  <CardContentEx>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 500,
                        width: '100%'
                      }}>
                      <Space direction="vertical">
                        <Row justify="center">
                          <Avatar size={72} src={LogoNoMaterial} />
                        </Row>
                        <Text size={20}>ยังไม่มีประกาศรับซื้อ</Text>
                      </Space>
                    </div>
                  </CardContentEx>
                )}
              </Row>
            )}
            {action === ACTION.DETAIL && (
              <FactoryDetail factory={factoryDetail} />
            )}
          </CardContentEx>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 500
            }}>
            <Spin />
          </div>
        )}
      </CardMaterialEx>
    </div>
  )
}

export default compose(withRouter, withContext)(FactoryAnnouncement)



// WEBPACK FOOTER //
// ./src/pages/FactoryAnnouncement/index.js